<!-- eslint-disable -->
<template>
  <CommonPages id="about" classs="about-page" titlePrefix="About Us - Ramnil"
    metaDescription="Connect with premium ad inventory, leverage real-time bidding, and optimize campaigns with data-driven insights. Trusted technology and expert support help you reach the right audience and achieve measurable results.">
    <div class="page-header"></div>
    <section class="about-story-section">
      <div class="about-story-section__content">
        <h1 class="about-story-section__title">Our story</h1>
        <p class="about-story-section__description">
          Founded by industry veterans, we simplify ad trading with innovative technology and dedicated support.
        </p>
      </div>
      <div class="about-story-section__image-container">
        <img src="@/assets/story-1.png" alt="Our story" class="about-story-section__image">
      </div>
    </section>
    <section class="about-connect-section">
      <div class="about-connect-section__image-container">
        <img src="@/assets/story-2.png" alt="Connecting advertisers"
          class="about-connect-section__image">
      </div>
      <div class="about-connect-section__content">
        <h2 class="about-connect-section__title">Connecting Advertisers Seamlessly</h2>
        <p class="about-connect-section__description">
          We’ve empowered hundreds of clients worldwide to efficiently buy and sell advertising inventory, driving measurable growth. Committed to innovation and excellence, we continuously adapt to the evolving digital advertising landscape.
        </p>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import '@/css/about.scss';

export default {
  name: 'About',
  components: {
    CommonPages,
  },
};
</script>
